import { styled } from 'stitches.config'

export const RelatedPostsRoot = styled('div', {
  marginTop: '$10',
  backgroundColor: '$error-100',
  paddingBottom: '$9',
  padding: '$4',
  borderRadius: '22px 22px 0 0',

  '@bp2': {
    marginTop: '144px',
    borderRadius: '75px 75px 0 0',
    paddingTop: '$7',
    paddingBottom: '$10',
  },
})

export const RelatedPostsGrid = styled('div', {
  display: 'grid',
  gridGap: '$4',
  gridTemplateColumns: 'repeat(auto-fill, 377px)',
  placeContent: 'center',
})

export const DottedLine = styled('div', {
  height: '$5',
  borderLeft: '4px dotted $primary-500',

  '@bp2': {
    height: '$8',
  },
})
